import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';

export interface ListHeadlineProps {
    dense?: boolean;
}

const ListHeadline = styled.h5`
    padding: ${(props: ListHeadlineProps) => (props.dense ? getSpacingToken('50') : getSpacingToken('100'))}px
        ${getSpacingToken('200')}px;
    margin: 0;
    ${getTextTokenPreset('bodyMedium')};
    color: ${getToken('textStaticSecondary')};
    pointer-events: none;
`;

export default ListHeadline;
